export enum SIGNUP_STATUS {
  CREATE_ACCOUNT = "CREATE_ACCOUNT",
  UPDATE_SCHOOL_PROFILE = "UPDATE_SCHOOL_PROFILE",
  INVITE_MEMBERS = "INVITE_MEMBERS",
  GET_STARTED = "GET_STARTED",
  COMPLETED = "COMPLETED",
}

export const SIGNUP_STATUS_KEY = "signup-status";

export enum LOGIN_STATUS {
  EMAIL_VERIFICATION = "EMAIL_VERIFICATION",
  VERIFICATION_LINK = "VERIFICATION_LINK",
  PASSWORD_CONFIRMATION = "PASSWORD_CONFIRMATION",
  SIGNUP_PENDING = "SIGNUP_PENDING",
  SUCCESS = "SUCCESS",
}

export const LOGIN_STATUS_KEY = "login-status";

export const AUTH_DETAILS_KEY = "auth-details";
